module.exports = __webpack_public_path__ + "static/media/sql_logo.50156c71.png";